// extracted by mini-css-extract-plugin
export default {"wrapper":"priests_wrapper__Qs9pX","priest":"priests_priest__z8kw0","name":"priests_name__W-ns0","info":"priests_info__mzmsg"};